// extracted by mini-css-extract-plugin
export var table = "_xo-0";